/**
 * SF-4651: says plainly whether demos made here land on stage or production. The admin app's own
 * environment is the Vite build mode (`npm run build:staging` -> "staging", `npm run build` ->
 * "production"); a build's is the sf-api NODE_ENV it was started on ("staging" | "production").
 */
import { Alert, Tag } from 'antd';
import { APP_ENVIRONMENT } from '../../../config/env';
import { environmentLabel, isProduction } from '../constants';

export const EnvironmentTag: React.FC<{ env: string | null | undefined }> = ({ env }) => (
  <Tag color={isProduction(env) ? 'red' : 'blue'}>{environmentLabel(env)}</Tag>
);

/** The page banner: production is red and says real customers can see it. */
export const EnvironmentBanner: React.FC = () =>
  isProduction(APP_ENVIRONMENT) ? (
    <Alert
      type="error"
      showIcon
      data-testid="environment-banner"
      message="Production"
      description="Demos made here are created on the live platform."
    />
  ) : (
    <Alert
      type="info"
      showIcon
      data-testid="environment-banner"
      message="Stage"
      description="Demos made here are created on stage, not on the live platform."
    />
  );
